import React, { useState } from "react";
import Input from "../../controls/Input";
import { useFormik } from "formik";
import * as yup from "yup";
import { HiMenu } from "react-icons/hi";
import * as applicationUserCrud from "../../../configurations/crud/applicationUserCrud";
import { MdErrorOutline } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Container from "../../base/Container";
import LodingButton from "../../controls/LodingButton";
import { CiLocationArrow1 } from "react-icons/ci";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import Card from "../../controls/Card";
import useGlobalLoader from "../../../configurations/useGlobalLoader";

const schema = yup.object().shape({
  userId: yup.string().required("user id is required."),
  oldPin: yup
    .string()
    .min(4, "Pin must have 4 digit")
    .max(4, "Pin must have 4 digit")
    .matches(/(?=.*[0-9])(?=.{4,})/, {
      message: "Pin should contains only digit.",
    })
    .required("Current Pin is required."),
  newPin: yup
    .string()
    .min(4, "Pin must have 4 digit")
    .max(4, "Pin must have 4 digit")
    .matches(/(?=.*[0-9])(?=.{4,})/, {
      message: "Pin should contains only digit.",
    })
    .required("New Pin is required."),
  confirmPin: yup
    .string()
    .oneOf([yup.ref("newPin"), null], "New pin and Confirm pin missmatch")
    .min(4, "Pin must have 4 digit")
    .max(4, "Pin must have 4 digit")
    .matches(/(?=.*[0-9])(?=.{4,})/, {
      message: "Pin should contains only digit.",
    })
    .required("Confirm Pin is required."),
});

export default function ChangePin() {
  const {start,end} = useGlobalLoader()
  const [level, setLevel] = useState(1);
  const [loding, setLoding] = useState(false);
  const toast = useToast();

  const {
    values,
    errors,
    isValid,
    handleBlur,
    handleChange,
    handleSubmit,
    touched,
    setValues,
  } = useFormik({
    initialValues: {
      userId: "none",
      oldPin: "",
      newPin: "",
      confirmPin: "",
    },
    validationSchema: schema,
    onSubmit(values) {
      handleChangePin(values);
    },
  });
  function handleChangePin(val) {
    setLoding(true);
    start()
    applicationUserCrud
      .ChangePin(values)
      .then((res) => {
        if (res.data) {
          let data = res.data;
          if (data.succeeded) {
            setLevel(0);
            toast.open(
              "Pin has been changed successfully.",
              <IoCheckmarkDoneCircleOutline />,
              "success"
            );
          } else {
            toast.open(data.message, <MdErrorOutline />, "danger");
          }
        } else {
          toast.open("Server Error", <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setLoding(false)
        end()
        toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
      });
  }
  return (
    <>
      <Container
        heading={
          <>
            {" "}
            Change Pin <CiLocationArrow1 />
          </>
        }
      >
        {level === 1 ? (
          <>
            <div class="w-full md:w-4/12 md:mx-2"></div>
            <div class="w-full md:w-4/12 md:mx-2">
              <Card title={"Change Pin"} isBorder={true}>
                <form className="px-3" onSubmit={handleSubmit}>
                  <div>
                    <label
                      htmlFor="oldPin"
                      className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                    >
                      Current Pin
                    </label>
                    <div className="mt-2">
                      <Input
                        type="password"
                        placeholder="Current Pin"
                        id="oldPin"
                        Icon={<HiMenu className="h-6 w-6" />}
                        value={values.oldPin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.oldPin && touched.oldPin}
                      />
                      {errors.oldPin && touched.oldPin && (
                        <p className="text-red-600 text-xs">{errors.oldPin}</p>
                      )}
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="newPin"
                      className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                    >
                      New Pin
                    </label>
                    <div className="mt-2">
                      <Input
                        type="password"
                        placeholder="New Pin"
                        id="newPin"
                        Icon={<HiMenu className="h-6 w-6" />}
                        value={values.newPin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.newPin && touched.newPin}
                      />
                      {errors.newPin && touched.newPin && (
                        <p className="text-red-600 text-xs">{errors.newPin}</p>
                      )}
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="confirmPin"
                      className="block text-sm mt-4 font-medium leading-6 text-gray-900"
                    >
                      Confirm Pin
                    </label>
                    <div className="mt-2">
                      <Input
                        type="password"
                        placeholder="Confirm Pin"
                        id="confirmPin"
                        Icon={<HiMenu className="h-6 w-6" />}
                        value={values.confirmPin}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isError={errors.confirmPin && touched.confirmPin}
                      />
                      {errors.confirmPin && touched.confirmPin && (
                        <p className="text-red-600 text-xs">
                          {errors.confirmPin}
                        </p>
                      )}
                    </div>
                  </div>
                  <div class="mt-4">
                    {!loding ? (
                      <button
                        type="submit"
                        className={!isValid ? "btn-blue-disabled" : "btn-blue"}
                        disabled={!isValid}
                      >
                        Save
                      </button>
                    ) : (
                      <LodingButton text="Wait.." />
                    )}
                  </div>
                </form>
              </Card>
            </div>
          </>
        ) : (
          <>
            <div class="w-full md:w-4/12 md:mx-2"></div>
            <div class="w-full md:w-4/12 md:mx-2">
              <Card title={"Change Pin"} isBorder={true}>
                <div className="flex flex-col">
                  <h1 className="text-2xl">Pin has been updated successfully.</h1>
                  <div className="flex">
                    <button
                      className="hyper-link flex w-full justify-center cursor-pointer px-3 py-1.5 text-sm"
                      onClick={() => {
                        setLevel(1);
                        setValues({
                          userId: "none",
                          oldPin: "",
                          newPin: "",
                          confirmPin: "",
                        });
                      }}
                    >
                      Reset Again
                    </button>
                  </div>
                </div>
              </Card>
            </div>

          </>
        )}
      </Container>
    </>
  );
}
